import {
  EmployeeIdentificationType,
  EmploymentPeriodStatusEnum,
  EmploymentViewModelNew,
  MarkupStatusEnum,
  UpdateEmploymentInput,
} from '@fora-monorepo/employer-my-pages-common/types';
import { isCoordinationNumber } from '@fora-monorepo/employer-my-pages-input-validation';

export const mockUpdateEmployment = (
  unchangedEmployment: EmploymentViewModelNew,
  updateEmploymentInput: UpdateEmploymentInput
): EmploymentViewModelNew => {
  return {
    foraAgreementNumber: unchangedEmployment.foraAgreementNumber,
    policyNumber: unchangedEmployment.policyNumber,
    employee: {
      employeeId: updateEmploymentInput.employeeId ?? unchangedEmployment.employee.employeeId,
      partnerNumberIndividual: unchangedEmployment.employee.partnerNumberIndividual,
      identificationType: isCoordinationNumber(
        updateEmploymentInput.employeeId ?? unchangedEmployment.employee.employeeId
      )
        ? EmployeeIdentificationType.CoOrdinationNumber
        : EmployeeIdentificationType.PersonalIdentityNumber,
      firstName: updateEmploymentInput.firstName ?? unchangedEmployment.employee.firstName,
      lastName: updateEmploymentInput.lastName ?? unchangedEmployment.employee.lastName,
      birthDate: unchangedEmployment.employee.birthDate,
      deathDate: unchangedEmployment.employee.deathDate,
      isVerified: unchangedEmployment.employee.isVerified,
      address: {
        coAddress: updateEmploymentInput.addressInfo?.coAddress,
        streetAddress: updateEmploymentInput.addressInfo?.streetAddress ?? '',
        streetAddress2: updateEmploymentInput.addressInfo?.streetAddress2 ?? '',
        postalCode: updateEmploymentInput.addressInfo?.postalCode,
        city: updateEmploymentInput.addressInfo?.city ?? '',
        countryCode: updateEmploymentInput.addressInfo?.countryCode ?? '',
      },
    },
    employmentPeriods: unchangedEmployment.employmentPeriods.map((empPeriod, index) => {
      if (updateEmploymentInput.employmentPeriod?.index === index) {
        return {
          ...updateEmploymentInput.employmentPeriod,
          employmentStatus: EmploymentPeriodStatusEnum.Active,
          markups: updateEmploymentInput.employmentPeriod.markups.map(markup => ({
            ...markup,
            faGroupId: '0000039884',
            fokText: 'FOK123MOCK',
            endDate: null,
            status: MarkupStatusEnum.Active,
          })),
          fokParameterChoices: updateEmploymentInput.employmentPeriod.fokParameterChoices.map(fokParameterChoice => ({
            ...fokParameterChoice,
            startDate: fokParameterChoice.startDate ?? '2024-01-01',
            endDate: fokParameterChoice.endDate ?? null,
          })),
        };
      }
      return empPeriod;
    }),
    activeMarkup: null,
    hasFokParameterChoices: (updateEmploymentInput.employmentPeriod?.fokParameterChoices?.length ?? 0) > 0,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  };
};
